module.exports = __webpack_public_path__ + "img/a2.ba7b4532.png";